var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIris = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.048.468h18.244v13.32H.048z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.552)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.779.468C2.879.468 0 2.653 0 6.308c0 3.542 3.28 5.747 6.13 5.747 3.14 0 4.653-.984 7.298-.45 2.068.417 3.184 1.429 3.739 1.959.265.255.603.283.832.131.23-.151.385-.438.23-1.123-.36-1.596-1.211-3.382-2.198-4.905C14.092 4.673 10.16.468 5.78.468",
    fill: "#3c8200",
    fillRule: "nonzero",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.609 10.02c2.898 0 5.78 2.185 5.78 5.84 0 3.542-3.281 5.747-6.134 5.747-3.137 0-4.65-.984-7.295-.45-2.067.417-3.186 1.429-3.739 1.959-.266.255-.603.283-.832.131-.231-.151-.386-.438-.231-1.123.362-1.596 1.213-3.382 2.198-4.905 1.939-2.994 5.873-7.199 10.253-7.199",
    fill: "#3c8200",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.008 8.234c-2.036 2.783-4.801 3.677-6.814 8.035-2.014-4.358-4.778-5.252-6.813-8.035-.518-.708-.806-1.484-.806-2.33 0-2.234 1.808-4.08 4.044-4.08 1.942 0 3.151 1.463 3.575 2.506.423-1.043 1.633-2.506 3.575-2.506 2.236 0 4.044 1.846 4.044 4.08 0 .846-.289 1.622-.805 2.33zM22.905.15c-1.62 0-2.959.68-3.712 1.674-.75-.995-2.09-1.674-3.71-1.674-2.93 0-5.621 2.334-5.621 5.72 0 1.483.596 2.61 1.136 3.399.616.898 1.426 1.674 2.7 2.78 1.846 1.605 3.366 3.17 4.818 6.232.114.244.36.52.677.52.319 0 .564-.276.68-.52 1.45-3.062 2.97-4.627 4.817-6.231 1.273-1.107 2.084-1.883 2.699-2.781.541-.788 1.137-1.916 1.137-3.4 0-3.385-2.69-5.72-5.621-5.72z",
    fill: "#3c8200",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIris);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iris.f3f33817cd794ed3d7afea397cd1f837.svg";